<template>
  <Bundle>
    <div
      class="flex flex-col justify-between gap-8 md:flex-row md:items-center"
    >
      <div class="flex flex-col gap-4">
        <RevIllustration
          alt=""
          :height="27"
          sizes="82px"
          src="/img/insurance/backUpLogo.svg"
          :width="82"
        />

        <RevLink class="body-1-link" @click="updateOffer">
          {{ offer.title }}
        </RevLink>
      </div>

      <div class="flex flex-row items-end justify-between gap-8 md:flex-col">
        <InsurancePrice
          v-if="offer.price && offer.price.amount !== '0.00'"
          class="!text-static-default-hi !heading-3"
          :is-monthly="offer.isMonthly"
          :price="offer.price"
        />

        <RevButton
          :loading="isLoading"
          size="small"
          variant="secondaryDestructive"
          @click="removeOffer"
        >
          {{ i18n(translations.remove) }}
        </RevButton>
      </div>
    </div>
  </Bundle>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

import type { InsuranceOfferWithSelectedState } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'

import InsurancePrice from '~/scopes/insurance/components/InsuranceOffers/components/InsuranceRadio/components/InsurancePrice/InsurancePrice.vue'

import Bundle from '../../../Bundle/Bundle.vue'
import { MODAL_NAME } from '../../InsurancesV2.constants'

import translations from './SelectedOffer.translations'

const props = defineProps<{
  listingId: string
  offer: InsuranceOfferWithSelectedState
}>()

const emit = defineEmits<{
  remove: [offer: InsuranceOfferWithSelectedState]
}>()

const i18n = useI18n()
const { trackClick } = useTracking()
const $httpFetch = useHttpFetch()
const isLoading = ref(false)

function updateOffer() {
  trackClick({
    name: 'edit_insurance',
    zone: 'cart',
  })

  openModal(`${MODAL_NAME}_${props.listingId}`)
}

async function removeOffer() {
  try {
    isLoading.value = true

    trackClick({
      name: 'remove_insurance',
      zone: 'cart',
    })

    await $httpFetch('/bm/cart/update_insurance_offer', {
      method: 'POST',
      body: {
        listing_id: props.listingId,
        insurance_offer_id: null,
      },
    })

    emit('remove', { ...props.offer, selected: false })
    isLoading.value = false
  } catch {
    isLoading.value = false
  }
}
</script>
